import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "results","filtersToggle", "filtersToggleButton", "additionalFilters", "activeFilters", "searchInput"]
  
  search(event) {
    // console.log("search controller search", event.key)
    // check if the enter key has been pressed
    if (event.key === 'Enter') {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent("search:deselectAll"))
      this.refresh();
    } 
  }

  reorder() {
    this.refresh();    
  }

  refresh() {
    if (this.hasFormTarget) {
      // console.log("search controller refresh")
      event?.preventDefault();
      event?.stopPropagation();
      this.updateURL();
      this.formTarget.requestSubmit()
    }
  }

  connect() {
    document.body.classList.remove('loading');
    this.boundRefresh = this.refresh.bind(this);
    document.addEventListener('search:refresh', this.boundRefresh);
    document.addEventListener('filter-change', this.filterChange);
  }

  disconnect() {
    document.removeEventListener('search:refresh', this.boundRefresh);
    document.removeEventListener('filter-change', this.filterChange);
  }

  /** Same query string the form would submit (movement row checkboxes live outside <form>, in #movements). */
  paramsFromSearchForm() {
    const params = new URLSearchParams()
    const currentParams = new URLSearchParams(window.location.search)
    if (!this.hasFormTarget) return params
    Array.from(this.formTarget.elements).forEach((element) => {
      if (element.name) {
        if (element.type == 'checkbox' || element.type == 'radio') {
          // Disabled controls are excluded, matching native form submission
          // (e.g. sites covered by a selected group in grouped-filter-select)
          if (element.checked && !element.disabled) {
            if (element.name.endsWith('[]')) {
              params.append(element.name, element.value)
            } else {
              params.set(element.name, element.value)
            }
          }
        } else {
          if (element.value || ['q', 'selected_ids', 'unselected_ids', 'select_all'].includes(element.name)) {
            params.set(element.name, element.value)
          }
        }
      }
    })
    if (!params.has("tab") && currentParams.has("tab")) {
      params.set("tab", currentParams.get("tab"))
    }
    if (!params.has("direction") && currentParams.has("direction")) {
      params.set("direction", currentParams.get("direction"))
    }
    return params
  }

  updateURL() {
    const params = this.paramsFromSearchForm()
    window.history.pushState(history.state, "", `${location.pathname}?${params}`)
  }

  filterChange = (event) => {
    this.refresh();
  }

}
